import { useEffect, useRef, useState } from "react";
import { store } from "../store";
import { IMAGE_MODAL_ACTION } from "../store/root/root.actions";

export const beutifyText = (number: number) => {
  const SYMBOLS = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const regex = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i: number;
  for (i = SYMBOLS.length - 1; i > 0; i--) {
    if (number >= SYMBOLS[i].value) {
      break;
    }
  }
  const value =
    (number / SYMBOLS[i].value).toFixed(1).replace(regex, "$1") +
    SYMBOLS[i].symbol;
  return value;
};

export const isImage = (url: string) => {
  return (
    String(url || "").match(/\.(jpeg|jpg|gif|png|svg)$/) != null &&
    (url || "").startsWith("https")
  );
};

export const isNumber = (value: any) => {
  return typeof value === "number";
};

export default function useDebounce(value: any, delay: number = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const useUpdateEffect = (effect: Function, dependencies: any[] = []) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);
};

export const showImageModal = (imageUrl: string) => {
  store.dispatch(IMAGE_MODAL_ACTION({ open: true, url: imageUrl }));
};

export const closeImageModal = () => {
  store.dispatch(IMAGE_MODAL_ACTION({ open: false, url: "" }));
};
